module.exports = __webpack_public_path__ + "img/guapaijiaoyi.0254aae.png";